'use client';

import { type JSX } from 'react';

import IconAction from '../shared/IconAction';
import { telemetryClickHandler } from '../telemetryHandler';
import type { ActionItemConfig } from '../types';

interface DesktopNavActionsProps {
    items: ActionItemConfig[];
    darkHeader?: boolean;
}

export default function DesktopNavActions({ items, darkHeader = false }: DesktopNavActionsProps): JSX.Element {
    return (
        <div className="hidden items-center gap-6 topnav-xl:flex">
            {items.map((item) => {
                if (item.type === 'link') {
                    return (
                        <a
                            key={item.href}
                            href={item.href}
                            className={`text-base font-normal hover:opacity-80 ${darkHeader ? 'text-white' : 'text-gray-900'}`}
                            onClick={telemetryClickHandler(item.telemetrySlug, item.telemetryEvents)}
                        >
                            {item.label}
                        </a>
                    );
                }

                if (item.type === 'cta') {
                    return (
                        <a
                            key={item.href}
                            href={item.href}
                            className="flex h-10 items-center justify-center rounded-[10px] bg-yellow-400 px-6 text-sm font-semibold text-gray-900 hover:bg-yellow-500"
                            onClick={telemetryClickHandler(item.telemetrySlug, item.telemetryEvents)}
                        >
                            {item.label}
                        </a>
                    );
                }

                return <IconAction key={item.href} item={item} darkHeader={darkHeader} />;
            })}
        </div>
    );
}
